<template>
    <div class="p-error grid">
        <div class="grid--container">
            <div class="grid--row">
                <div class="grid--col p-error--aside">
                    <div class="p-error--inner">
                        <div class="p-error--img-wrap">
                            <img class="p-error--img" :src="'img/bug.png' | static">
                        </div>
                    </div>
                </div>
                <div class="grid--col p-error--main">
                    <cmp-error-404-content></cmp-error-404-content>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import routeMixin from 'vue/mixins/route';

    export default {
        mixins: [
            routeMixin,
        ],
    };
</script>



// WEBPACK FOOTER //
// index.vue?f5e197c2